export const INTEGRATION_FIELD_PRESET_VALUES = {
  iframeLink: 'iframeLink',
} as const;

const IFRAME_LINK_PRESET_URL = 'https://echogpt.ai/api/iframe/show/@client_uuid';

export const getIframeLinkPresetUrl = (host?: string) => {
  const currentHost = host ?? (typeof window === 'undefined' ? null : window.location.host);
  if (!currentHost) return IFRAME_LINK_PRESET_URL;

  const url = new URL(IFRAME_LINK_PRESET_URL);
  url.host = currentHost;

  return url.toString();
};

export const INTEGRATION_FIELD_PRESET_URLS = {
  iframeLink: getIframeLinkPresetUrl(),
} as const;

export type IntegrationFieldPresetValue =
  (typeof INTEGRATION_FIELD_PRESET_VALUES)[keyof typeof INTEGRATION_FIELD_PRESET_VALUES];

export const getIntegrationFieldPresetByValue = (
  value?: string | null,
): IntegrationFieldPresetValue | null => {
  if (!value) return null;

  try {
    const candidate = new URL(value);
    const preset = new URL(IFRAME_LINK_PRESET_URL);
    const matchesIframePreset =
      candidate.protocol === preset.protocol &&
      candidate.username === preset.username &&
      candidate.password === preset.password &&
      candidate.pathname === preset.pathname &&
      candidate.search === preset.search &&
      candidate.hash === preset.hash;

    if (matchesIframePreset) {
      return INTEGRATION_FIELD_PRESET_VALUES.iframeLink;
    }
  } catch {
    return null;
  }

  return null;
};
